module.exports = __webpack_public_path__ + "img/1.679ca744.jpg";